<div class="content">
    <p class="description">
        {{title}}
    </p>
</div>

